/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import BasicUnit from 'astro/server/unit/basic';


export default class extends BasicUnit
{
  installPassiveBenefit ()
  {
    this.getZone().getAttributes().setInfluenceStrength(2);
  }


}
